import * as React from 'react'
import { AutoCompleteInput, FormField, Label } from 'uxp/components';
import { IContextProvider } from '../../../uxp';
import { tryParseJSON } from '../../../util';
import { IWDDesignModeProps } from "../common";
import { IContextData } from '../../../hooks/useContextData';
import { ILucyAction } from './action-types';
import { ActionParameterEditor } from './ActionParameterEditor';
import { $L } from '../../../localize';
import './ActionEditor.scss';

export const LucyActionEditor: React.FunctionComponent<{ value: ILucyAction, onChange: (v: ILucyAction) => void, uxpContext?: IContextProvider, contextData?: IContextData, designer?: IWDDesignModeProps, uiProps: any, disableParameters?: boolean }> = (props) => {
    let action: ILucyAction = props.value || { action: '', modelName: '', params: {} };

    let [models, setModels] = React.useState([])
    let [actions, setActions] = React.useState([])

    React.useEffect(() => {
        getAllModels()
    }, [])

    React.useEffect(() => {
        if (action.modelName) {
            getAllActions(action.modelName)
        }
    }, [action])

    async function getActionDetails(model: string, action: string) {
        return new Promise((done, nope) => {
            props?.uxpContext?.executeService('System', 'MetadataMap:ActionDetailsByName', { 'Model': model, 'Action': action }, { json: true })
                .then(res => {
                    let definition = tryParseJSON(res[0]?.Definition || {}, {})
                    let params: any = {}
                    if (definition.parameters) {
                        definition.parameters.map((p: string) => {
                            params[p] = ''
                        })
                    }
                    done(params)
                })
                .catch(e => {
                    console.log("unable to get the params ", e);
                    done({})
                })
        })
    }

    function getAllModels() {
        props?.uxpContext?.executeService('System', 'MetadataMap:ActiveModelNames', {}, { json: true })
            .then(res => {
                let models = res.flatMap((m: any) => m.ObjectID)
                setModels(models)
            })
            .catch(e => {
                console.log('excepton ', e);
            })
    }

    function getAllActions(model: string) {
        props?.uxpContext?.executeService("System", "MetadataMap:ActiveModelActions", { modelName: model }, { json: true })
            .then(res => {
                let actions = res.flatMap((a: any) => a.ObjectID)
                setActions(actions)
            })
            .catch(e => console.log(e))
    }


    return <div className='lucy-action-editor'>
        <FormField>
            <Label className="uxp_wd-axn-editor__field">{$L('widgetdesigner.actions.model', 'Model')}</Label>
            <AutoCompleteInput
                value={action.modelName || ''}
                onChange={(txt) => {
                    let _action = { ...action }
                    _action.modelName = txt
                    if (txt.trim().length == 0) {
                        _action.action = ''
                        _action.params = {}
                    }
                    props.onChange(_action)
                }}
                options={models}
                className="uxp_wd-axn-editor__field"
                placeholder={$L('widgetdesigner.actions.model-placeholder', 'Model name')}
            />
        </FormField>
        <FormField>
            <Label className="uxp_wd-axn-editor__field">{$L('widgetdesigner.props.action', 'Action')}</Label>

            <AutoCompleteInput
                value={action.action || ''}
                onChange={(txt) => {

                    getActionDetails(action.modelName, txt)
                        .then(res => {
                            let _action = { ...action }
                            _action.action = txt
                            _action.params = res || {}
                            props.onChange(_action)
                        })
                }}
                options={actions}
                className="uxp_wd-axn-editor__field"
                placeholder={$L('widgetdesigner.actions.action-placeholder', 'Action name')}
            />
        </FormField>
        {
            !props?.disableParameters && <FormField>
                <ActionParameterEditor
                    designer={props.designer}
                    uiProps={props.uiProps}
                    value={action.params}
                    onChange={(v) => props.onChange({ ...action, params: v })}
                    contextData={props.contextData}
                />
            </FormField>
        }

    </div>;
};
